import React, { useEffect, useState } from "react";
import moment, { duration } from "moment";
import {
    Container, CountdownContainer, Number, Text, Central
} from './TimerElements.js';
import {Typography} from '@material-ui/core';


function Timer(props) {
  const { date } = props;

  const [timer, setTimer] = useState(0);

  function setCountdown() {

    const futureDate = moment(date);
    const today = moment();
    const clockDuration = duration(futureDate.diff(today));
    let dana = Math.floor(clockDuration.asDays());
    let sati = clockDuration.hours();
    let minuta = clockDuration.minutes();
    let sekundi = clockDuration.seconds();

    if (Math.floor(clockDuration.asDays()) < 0){
         dana = 0;
    }

    if (clockDuration.hours() < 0){
         sati = 0;
    }

    if (clockDuration.minutes() < 0){
         minuta = 0;
    }

    if (clockDuration.seconds() < 0){
         sekundi = 0;
    }

    setTimer({
      dana: dana,
      sati: sati,
      minuta: minuta,
      sekundi: sekundi,
    });
  }

  useEffect(() => {
    setCountdown();
    const interval = setInterval(() => {
      setCountdown();
    }, 1000);

    return () => clearInterval(interval);
  }, []);

 
        return(
            <Container>
                <Typography variant="h4" style={{marginTop:"20px",color:"#0E1B4D",fontWeight:"bold",textAlign:"center"}}>
                    PREOSTALO VRIJEME DO KONFERENCIJE
                </Typography>
                <Central>
                {Object.keys(timer).map((key, i) => (
                    <CountdownContainer>
                        <Number>
                            {timer[key]}
                        </Number>
                        <Text>
                            {key.toUpperCase()}
                        </Text>
                    </CountdownContainer>
                ))}
            </Central>
            </Container>
        )
    }


export default Timer;